import searchSuggestionsConfigMcom from './mcom/searchSuggestions';
import searchSuggestionsConfigBcom from './bcom/searchSuggestions';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? searchSuggestionsConfigBcom : searchSuggestionsConfigMcom;
